import { render, staticRenderFns } from "./delete-module.vue?vue&type=template&id=2904d560&scoped=true&"
import script from "./delete-module.vue?vue&type=script&lang=js&"
export * from "./delete-module.vue?vue&type=script&lang=js&"
import style0 from "./delete-module.vue?vue&type=style&index=0&id=2904d560&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2904d560",
  null
  
)

export default component.exports